exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-6ff6a5fc]{width:100%}table tr[data-v-6ff6a5fc]{height:40px}.download-button[data-v-6ff6a5fc]{box-shadow:none}.download-button[data-v-6ff6a5fc] i{color:#e30613;font-size:1.1em}.failed[data-v-6ff6a5fc]{background:red}.failed[data-v-6ff6a5fc],.passed[data-v-6ff6a5fc]{color:#fff;padding:2px 15px;border-radius:10px;font-size:14px;font-weight:700}.passed[data-v-6ff6a5fc]{background:#90ee90}", ""]);

// exports
